import { Component, OnInit, ViewChildren, QueryList, ViewChild } from '@angular/core';
import { FormBuilder, Validators, FormGroup,NgForm } from '@angular/forms';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { APIEntityService } from '../../_services/entity/API-entity';
import { APILoginService } from '../../_services/login/API-login';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import { Constants } from '../../../../_utils/Constants';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { formatDate } from '@angular/common';
import { $BroadcastManagerService } from '../../../../_helpers/BroadcastManager.service';
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { DataSource } from '@angular/cdk/table';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';
import { style } from '@angular/animations';
import { MyDialogComponent } from '../../../../_helpers/Modals/my-dialog/my-dialog.component';
import { EntityDialogComponent } from '../../../../_helpers/Modals/entity-dialog/entity-dialog.component';

import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import * as CryptoJS from 'crypto-js';
import { saveAs as importedSaveAs } from "file-saver";
import {MatDatepickerInputEvent} from '@angular/material/datepicker';



const now = new Date();
const time_today = now.getTime();
const formatTime = formatDate(time_today, 'HH:mm', 'en-US', '+0530');
const currentdat = formatDate(now, 'dd-MM-yyyy', 'en-US', '+0530');
console.log("formatTime -- : ", formatTime);
//console.log("datecur :",  currentdat);
export interface DialogData {
  setValue: string,
  setRole: string
}
@Component({
  selector: 'app-consent-reports',
  templateUrl: './consent-reports.component.html',
  styleUrls: ['./consent-reports.component.css']
})
export class ConsentReportsComponent implements OnInit {

  maxDate: Date = new Date();
  mindate= new Date(now.getFullYear(),0,1);
  maxdate = new Date(now.getFullYear(),now.getMonth(),now.getDate())
  
  dataSource: MatTableDataSource<any>;
  onSelectdropdown: boolean = true;
  filterData: any;
  noRecord: any;
  UrnFromURL: any;
  afterApply:boolean=false;

  entityId:any;

  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
  @ViewChild('tSort') tSort: MatSort;
  

  dataSubject = new BehaviorSubject<any[]>([]);
 
  displayedColumns: string[] = ['CSTBulk_RefNo', 'CST_ID', 'CST_Oap', 'CST_Tap', 
  'Entity_ID', 'Msisdn', 'CST_Template_ID', 'Cst_Acq_Date', 
  'CST_Verification_Date', 'CST_Expiry_Date', 'CST_Status'];

  

  form1: any = {};
  

  constructor(
    private fb: FormBuilder,
    private es: APIEntityService,
    private ls: APILoginService,
    private $modal: $ModalManagerService,
    private db: $DBManagerService,
    public dialog: MatDialog,
    private $: $BroadcastManagerService) { }

  ngOnInit() {
    this.entityId = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID);
	let entityClass = this.db.get(Constants.SESSSION_STORAGE, Constants.USER_ROLE);
    if(entityClass == "Tata Employee"){
		this.getPECSTReportsAll(entityClass);
	}
	else{
		this.getPECSTReportsAll(this.entityId);
	}
       
   this.maxDate.setDate(new Date().getDate());
 }

 getPECSTReportsAll(id){
  this.es.getCSEntityConsentReports(id).subscribe(result=>{
    console.log("new data " +result);
    this.onChangeDataSource(result);
  })
 }

 onChangeDataSource(value) {
  console.log("values"+  value);
 this.dataSource = new MatTableDataSource(value);
 this.dataSource.paginator = this.paginator.toArray()[0];
 this.dataSource.sort = this.tSort;
 this.noRecord = this.dataSource.connect().pipe(map(data => data.length === 0));
}

searchRequired:boolean=false;
errorSerch(){
  if(this.form1.searchBy && !this.form1.search){
    this.searchRequired=true;
  }else{
    this.searchRequired=false;

  }
}

onSubmitFilter(filterForm,form) {
  if(!form.valid){
    return true;
  }
  if(this.form1.searchBy && !this.form1.search){
    this.searchRequired=true;
    return true;
 }else{
   this.searchRequired=false;

 }
        let fdate,ldate;
    if(filterForm.startDate){
     fdate = formatDate(filterForm.startDate , 'yyyy-MM-dd', 'en-US', '+0530');
    }
    // if( this.enddateError && filterForm.startDate){
    //   return true;
    // }
    if(filterForm.endDate){
     ldate = formatDate(filterForm.endDate, 'yyyy-MM-dd', 'en-US', '+0530');
    }
    if(filterForm.startDate && !filterForm.endDate){
      ldate=formatDate(now, 'yyyy-MM-dd', 'en-US', '+0530');
      
    }
    let searchVal;
    if(this.form1.search){
        searchVal=this.form1.search.trim();
    }
    let CST_Template_ID=filterForm.searchBy;
    let data={
      "filterType": filterForm.searchBy,
      [CST_Template_ID]: searchVal,
      "Start_Date":fdate ,
      "End_Date": ldate,
      'EntityID':this.entityId
    }
    var difference_in_Time=new Date(ldate).getTime()-new Date(fdate).getTime()
    var difference_in_Days=difference_in_Time/(1000*3600*24)
    console.log("difference_in_Timedifference_in_Time in days",difference_in_Time)
    if(fdate!=""&&ldate!="" &&difference_in_Days>30){
     alert("Date Difference should not be more than 30 days")
    }
    
   
    this.getAllEntityConsentReportsFilter(data);

  }
  getAllEntityConsentReportsFilter(data){ 
    this.es.getAllCSEntityConsentReportsFilter(data)
    .subscribe(r => {
      this.filterData = r;
      this.afterApply=true;
      this.onChangeDataSource(this.filterData);
      console.log("12345 :", this.filterData);
    })
  
  }

//   enddateError=false
// addEvent(event: MatDatepickerInputEvent<Date>) {
//     if(event.value){
//      this.enddateError=true;
//     }
// }
// addEventEnddate(event: MatDatepickerInputEvent<Date>) {
//   if(event.value){
//    this.enddateError=false;
//   }
// } 
  onOptionsSelected(data){
    
    if(data === "CST_Status"){
      this.onSelectdropdown=false;
    }else{
      this.onSelectdropdown=true;
    }
    this.form1.search="";
    }

    reset(){
      this.getPECSTReportsAll(this.entityId);
      console.log("first reset function");
      //this.enddateError=false;
      this.onSelectdropdown=true;
      this.searchRequired=false;
      this.afterApply=false;

      }

      downloadrejectedcsvfile(Status){     
        let data;  
        if(Object.keys(this.form1).length !== 0 && this.afterApply){
        let fdate =this.form1.stDate ? formatDate(this.form1.stDate , 'yyyy-MM-dd', 'en-US', '+0530') : undefined;
        let ldate = this.form1.enDate ? formatDate(this.form1.enDate, 'yyyy-MM-dd', 'en-US', '+0530') : undefined;
        let CST_Template_ID=this.form1.searchBy;
        if(this.form1.stDate && !this.form1.enDate){
          ldate=formatDate(now, 'yyyy-MM-dd', 'en-US', '+0530');
          
        }
         data={
          "filterType": this.form1.searchBy,
          [CST_Template_ID]: this.form1.search,
          "Start_Date":fdate ,
          "End_Date": ldate,
          'EntityID':this.entityId
        }
      }else{
        data={
          // "filterType": "TemplateStatus",
          // "TemplateStatus": "A"
          'EntityID':this.entityId
        }
    }
    // this.getAllEntityConsentReportsFilter(data);

        var fileName;
        const currentdat = formatDate(now, 'medium', 'en-US', '+0530');
        
        this.es.downloadCSEntityConsentReportssvfile(data).subscribe(r => {  
         if(Status=='A'){
           fileName = currentdat+ ' Approved Entity Consent Records.csv';
        }
        importedSaveAs(r, fileName)
        this.afterApply=false;   
        //  this.downloadFile(r, Batch_Id);     
          this.$modal.successModal({
            title: 'Principal Entity Consent Reports',
            msg: 'File has been downloaded Successfully'
          });   
        })
      }  



}
